"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneEmailDtoToJSON = exports.CertificazioneEmailDtoFromJSONTyped = exports.CertificazioneEmailDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function CertificazioneEmailDtoFromJSON(json) {
    return CertificazioneEmailDtoFromJSONTyped(json, false);
}
exports.CertificazioneEmailDtoFromJSON = CertificazioneEmailDtoFromJSON;
function CertificazioneEmailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'idCertificazione': !runtime_1.exists(json, 'idCertificazione') ? undefined : json['idCertificazione'],
        'idStatoCertificazione': !runtime_1.exists(json, 'idStatoCertificazione') ? undefined : json['idStatoCertificazione'],
        'token': !runtime_1.exists(json, 'token') ? undefined : json['token'],
        'emailCertificazione': !runtime_1.exists(json, 'emailCertificazione') ? undefined : json['emailCertificazione'],
        'cellulareCertificazione': !runtime_1.exists(json, 'cellulareCertificazione') ? undefined : json['cellulareCertificazione'],
        'oggettoEmail': !runtime_1.exists(json, 'oggettoEmail') ? undefined : json['oggettoEmail'],
        'testoEmail': !runtime_1.exists(json, 'testoEmail') ? undefined : json['testoEmail'],
        'ipAddressUtente': !runtime_1.exists(json, 'ipAddressUtente') ? undefined : json['ipAddressUtente'],
        'userAgentUtente': !runtime_1.exists(json, 'userAgentUtente') ? undefined : json['userAgentUtente'],
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
        'dataUltimaModifica': !runtime_1.exists(json, 'dataUltimaModifica') ? undefined : (new Date(json['dataUltimaModifica'])),
        'dataInvioEmail': !runtime_1.exists(json, 'dataInvioEmail') ? undefined : (json['dataInvioEmail'] === null ? null : new Date(json['dataInvioEmail'])),
        'dataScadenzaToken': !runtime_1.exists(json, 'dataScadenzaToken') ? undefined : (new Date(json['dataScadenzaToken'])),
        'dataCertificazione': !runtime_1.exists(json, 'dataCertificazione') ? undefined : (json['dataCertificazione'] === null ? null : new Date(json['dataCertificazione'])),
        'statoCertificazioneDesc': !runtime_1.exists(json, 'statoCertificazioneDesc') ? undefined : json['statoCertificazioneDesc'],
        'isInviata': !runtime_1.exists(json, 'isInviata') ? undefined : json['isInviata'],
        'erroreInvioEmail': !runtime_1.exists(json, 'erroreInvioEmail') ? undefined : json['erroreInvioEmail'],
    };
}
exports.CertificazioneEmailDtoFromJSONTyped = CertificazioneEmailDtoFromJSONTyped;
function CertificazioneEmailDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'idCertificazione': value.idCertificazione,
        'idStatoCertificazione': value.idStatoCertificazione,
        'token': value.token,
        'emailCertificazione': value.emailCertificazione,
        'cellulareCertificazione': value.cellulareCertificazione,
        'oggettoEmail': value.oggettoEmail,
        'testoEmail': value.testoEmail,
        'ipAddressUtente': value.ipAddressUtente,
        'userAgentUtente': value.userAgentUtente,
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
        'dataUltimaModifica': value.dataUltimaModifica === undefined ? undefined : (value.dataUltimaModifica.toISOString()),
        'dataInvioEmail': value.dataInvioEmail === undefined ? undefined : (value.dataInvioEmail === null ? null : value.dataInvioEmail.toISOString()),
        'dataScadenzaToken': value.dataScadenzaToken === undefined ? undefined : (value.dataScadenzaToken.toISOString()),
        'dataCertificazione': value.dataCertificazione === undefined ? undefined : (value.dataCertificazione === null ? null : value.dataCertificazione.toISOString()),
        'statoCertificazioneDesc': value.statoCertificazioneDesc,
        'isInviata': value.isInviata,
        'erroreInvioEmail': value.erroreInvioEmail,
    };
}
exports.CertificazioneEmailDtoToJSON = CertificazioneEmailDtoToJSON;
